export default {
    error: {
        BUSY: 'busy',
        ERROR: 'error',
        RESOURCE_CONSTRAINT: 'resource-constraint',
        UNEXPECTED_REQUEST: 'unexpected-request',
        SERVICE_UNAVAILABLE: 'service-unavailable'
    },
    mode: {
        FILE: 'file',
        STREAM: 'stream'
    },
    status: {
        OFF: 'off',
        ON: 'on',
        PENDING: 'pending'
    }
};
